import { useRef, useState, useLayoutEffect } from 'react';
import { Image } from 'react-bootstrap';
import Styles from './ZoomImage.module.scss?module';
import useViewports from '../../../../../Hooks/useViewports';
import SimpleMagnifier from '../../../../SimpleMagnifier/SimpleMagnifier';

const ZoomImage = ({
  src,
  alt = 'product image',
  size,
}: {
  src?: string | null;
  alt?: string;
  size?: { width: number; height: number; lensSize?: number };
}) => {
  const imageSrc = src ?? 'https://placehold.co/1000x1000';
  const { xs, sm, md } = useViewports();
  const containerRef = useRef<HTMLDivElement>(null);
  const [dimensions, setDimensions] = useState<{
    width: number;
    height: number;
  } | null>(null);

  useLayoutEffect(() => {
    if (!containerRef.current) return;

    const updateDimensions = () => {
      if (containerRef.current) {
        const { width } = containerRef.current.getBoundingClientRect();

        setDimensions({
          width: Math.floor(width),
          height: Math.floor(size?.height ?? width),
        });
      }
    };

    updateDimensions();

    const observer = new ResizeObserver(updateDimensions);
    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, [size?.height]);

  return (
    <div
      ref={containerRef}
      className={Styles.ImageContainer}
      style={{ minHeight: dimensions?.height || 225 }}
    >
      {xs || sm || md ? (
        <Image fluid src={imageSrc} className="h-auto" alt={alt} />
      ) : (
        dimensions && (
          <SimpleMagnifier
            src={imageSrc}
            width={dimensions.width}
            height={dimensions.height}
            lensSize={size?.lensSize ?? Math.floor(dimensions.width / 3)}
          />
        )
      )}
    </div>
  );
};

export default ZoomImage;
